import { Button, Modal, Table } from 'react-bootstrap';
import { IListItem, IMicrositeRecipientForList } from '@nkr/models/index';
import { MicrositeEmailType } from '@nkr/enums/microsite-email-type';

interface IProps {
    show: boolean,
    isAdmin: boolean,
    emailType: MicrositeEmailType,
    emailTypeList: IListItem[],
    list: IMicrositeRecipientForList[],
    onSubmit: () => void,
    onCancel: () => void
}

const BulkSendEmail: React.FC<IProps> = (props) => {
    const emailType = props.emailType > 0 ? props.emailTypeList.find(x => x.id == props.emailType).description : '';

    return (
        <Modal show={props.show} backdrop='static' onHide={props.onCancel}>
            <Modal.Header closeButton>Bulk Send {emailType} Email</Modal.Header>
            <Modal.Body>
                <Table condensed striped>
                    <thead>
                        <tr>
                            {props.isAdmin && (
                                <>
                                    <th>Center</th>
                                    <th>Coordinator</th>
                                </>
                            )}

                            <th>Name</th>
                            <th>Current Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.list.map((item, index) =>
                            <tr key={'bulk-deact-' + item.id}>
                                {props.isAdmin && (
                                    <>
                                        <td>{item.center.alias}</td>
                                        <td>{item.coordinatorContactName}</td>
                                    </>
                                )}

                                <td>{item.firstName} {item.lastName}</td>
                                <td>{item.currentStatusDescription}</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </Modal.Body >
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onSubmit}>Send</Button>
                <Button onClick={props.onCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default BulkSendEmail;